import http from '@/utils/http';

/** One time bucket (week or month) of the completion / cycle-time series. */
export interface ReportPeriod {
  bucket: string; // ISO instant of the period start (UTC)
  completed: number; // completion events that landed in this period
  avg_cycle_days: number;
  cycle_count: number;
}
export interface ReportTypeCount {
  type: string;
  count: number;
}
export interface AssigneeWorkload {
  assignee_id: string | null; // null = unassigned
  name: string;
  active: boolean;
  story: number;
  task: number;
  bug: number;
  total: number;
}
/** The whole /reports payload: throughput + cycle time over a bucketed window + current workloads. */
export interface ReportBundle {
  range_start: string;
  range_end: string;
  granularity: 'week' | 'month';
  periods: ReportPeriod[];
  total_completed: number;
  avg_cycle_days: number;
  median_cycle_days: number;
  completed_by_type: ReportTypeCount[];
  workload: AssigneeWorkload[];
  total_open: number;
  board_count: number;
}

/** Fetch the analytics bundle. Results are scoped server-side to the caller's accessible boards. */
export const getReports = (opts: { days?: number; granularity?: 'week' | 'month'; board?: string } = {}) =>
  http.get<ReportBundle>('/reports', { params: opts }).then((r) => r.data);
